import { IBalanceManager, BalanceShopItemTypeEnum } from './IBalanceManager';

export class CrazyGamesBalanceManager implements IBalanceManager {
    public getShopItemPrice(type: BalanceShopItemTypeEnum): number {
        switch (type) {
            case BalanceShopItemTypeEnum.needle:
                return 70;

            case BalanceShopItemTypeEnum.thread:
                return 70;

            case BalanceShopItemTypeEnum.combo:
                return 70;
        }
        return 0;
    }

    public getPicturePrice(size: number): number {
        switch (size) {
            case 15:
                return 15;
            case 25:
                return 25;
            case 40:
                return 40;
            case 50:
                return 50;
            case 70:
                return 70;
            case 100:
                return 100;
            case 150:
                return 150;

            case 200:
                return 200;
        }
        return 0;
    }

    public getPictureReward(size: number): number {
        // С появлением системы прогресса, общая награда за любую вышивку составляет 10 монет
        return 10;

        /*
        switch (size) {
            case 25:
                return 20;
            case 40:
                return 30;
            case 50:
                return 30;
            case 70:
                return 40;
            case 100:
                return 60;
            case 150:
                return 90;

            case 200:
                return 100;
        }
        return 0;
         */
    };

    public isPictureRewardAvaliable(size: number): boolean {
        return size <= 150;
    }

    public getBoxReward(): number {
        return 150;
    };
}
